var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMarkUnread = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#64B057"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 7.5a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10V7.5h11.288c-1.513-2-1.35-4.013-1.15-5H5.011a2.5 2.5 0 0 0-2.5 2.5L2.5 27.5l5-5H25c1.375 0 2.5-1.125 2.5-2.5V8.713c-1.05.8-2.337 1.287-3.75 1.287H7.5Zm10 7.5h-10V15h10v2.5Zm5-3.75h-15v-2.5h15v2.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#fff"
  })))));
};
export { SvgMarkUnread as ReactComponent };